<template>
  <base-layout v-if="ready">
    <div v-if="notFound === false">
      <v-row>
        <v-col
          sm="12"
          md="6"
          cols="12">
          <table>
            <tr
              v-for="(field, index) in headers"
              :key="index">
              <td class="pa-2">
                {{ field.text }} :
              </td>
              <td v-if="field.isDate">
                {{ displayTableValue(member, field.value) | localDate() }}
              </td>
              <td v-else>
                {{ displayTableValue(member, field.value) }}
              </td>
            </tr>
          </table>
        </v-col>
        <v-col>
          <paginate
            :page="parseInt(page)"
            :per-page="perPage"
            :total="spendingLogs.total"
            @on-page-change="changePage" />
          <TableSpendingLog :items="spendingLogs.results" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn
            outlined
            small
            @click="$router.go(-1)">
            Back
          </v-btn>
          <v-btn
            outlined
            small
            color="primary"
            class="ml-4"
            @click="editMember">
            Edit
          </v-btn>
          <v-btn
            outlined
            small
            color="pink"
            class="ml-4"
            @click="confirmDelete">
            Delete
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <NotfoundPage
      v-else
      message="Member not found" />
  </base-layout>
</template>

<script>
import { mapActions } from 'vuex'
import MemberProvider from '@/resources/MemberProvider'
import Paginate from '@/components/Paginate'
import NotfoundPage from '@/components/Notfound.vue'
import TableSpendingLog from '../components/TableSpendingLog.vue'

const memberService = new MemberProvider()
export default {
  components: {
    TableSpendingLog,
    Paginate,
    NotfoundPage
  },
  data () {
    return {
      member: {},
      spendingLogs: {},
      notFound: false,
      ready: false,
      perPage: 10,
      page: 1,
      headers: [
        { text: 'Tel', value: 'tel' },
        { text: 'Type', value: 'type' },
        { text: 'ID', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'DOB', value: 'birthDate' },
        { text: 'Gender', value: 'gender' },
        { text: 'Email', value: 'email' },
        { text: 'Source', value: 'createdIn' },
        { text: 'Point', value: 'point' },
        { text: 'Card ID', value: 'cardId' },
        { text: 'Member Date', value: 'createdAt', isDate: true },
        { text: 'VIP Date', value: 'vipDate', isDate: true },
        { text: 'Total Spend', value: 'spending.total' }
      ]
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    }
  },
  mounted () {
    this.getMember()
    this.getMemberSpendingLog()
  },
  methods: {
    ...mapActions({
      setLoading: 'Style/setLoading',
      setSnackbar: 'Style/setSnackbar',
      setModal: 'Style/setModal'
    }),
    changePage (page) {
      this.page = page
      this.getMemberSpendingLog()
    },
    async getMemberSpendingLog () {
      try {
        await this.setLoading({
          active: true,
          clickAble: false,
          message: 'Getting Data.'
        })
        const query = `page=${this.page}&limit=${this.perPage}`
        const { data } = await memberService.getMemberSpendingById(this.id, query)
        this.spendingLogs = data
      } catch (err) {
        this.setSnackbar({
          message: err.message,
          type: 'pink',
          timeout: 5000,
          canClose: true,
          value: true
        })
      } finally {
        await this.setLoading({
          active: false,
          clickAble: false,
          message: 'Getting Data.'
        })
      }
    },
    async getMember () {
      try {
        this.notFound = false
        const { data } = await memberService.getMemberById(this.id)
        this.member = data
        this.member.name = `${data.firstName} ${data.lastName}`
      } catch (err) {
        this.notFound = true
        this.setSnackbar({
          message: err.message,
          type: 'pink',
          timeout: 5000,
          canClose: true,
          value: true
        })
      } finally {
        this.ready = true
      }
    },
    displayTableValue (member, value) {
      const splitValue = value.split('.')
      if (splitValue.length === 2) {
        return member[splitValue[0]][splitValue[1]]
      }
      return member[splitValue[0]] !== '' ? member[splitValue[0]] : '-'
    },
    editMember () {
      this.$router.push({ name: 'MemberEdit', params: { id: this.id } })
    },
    confirmDelete () {
      this.setModal({
        confirmText: 'Delete',
        cancelText: 'Cancel',
        message: `Delete Member id ${this.id}`,
        title: 'Confirm Delete',
        value: true,
        confirmOnly: false,
        confirmType: 'success',
        onConfirm: this.deleteMember,
        onCancel: null
      })
    },
    async deleteMember () {
      try {
        await memberService.deleteMember(this.id)
        this.setSnackbar({
          message: 'Delete Success!',
          type: 'success',
          timeout: 3000,
          canClose: true,
          value: true
        })
        this.$router.go(-1)
      } catch (err) {
        this.setSnackbar({
          message: err.message,
          type: 'pink',
          timeout: 5000,
          canClose: true,
          value: true
        })
      }
    }
  }
}
</script>
<style scoped>
.fade-in {
  transition:opacity 0.8s
}
</style>
